export const REQUEST_MESSAGES_PENDING='REQUEST_MESSAGES_PENDING'
export const REQUEST_MESSAGES_SUCCESS='REQUEST_MESSAGES_SUCCESS'
export const REQUEST_MESSAGES_FAILED='REQUEST_MESSAGES_FAILED'
export const RECEIVE_MESSAGE='RECEIVE_MESSAGE'